import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createSlots as _createSlots, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-45fbba9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gutter-box1" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "display-line1" }
const _hoisted_4 = { style: {"font-size":"14px","color":"gray"} }
const _hoisted_5 = { class: "gutter-box2" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "gutter-box3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"margin-top":"5px"} }, "佰特编码CTO", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"left","color":"#606266"} }, " 物联网科技公司创始人、互联网资深技术专家、分布式与微服务架构专家。一直致力于分布式系统架构、微服务、云计算与物联网技术的研究。 在智慧城市、智慧医疗、智慧物流、智慧停车等领域拥有丰富的项目与架构经验。 ", -1))
const _hoisted_10 = { style: {"margin-top":"5px"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-primary" }, "yinjisheng@126.com", -1))
const _hoisted_12 = { class: "gutter-box4" }
const _hoisted_13 = { class: "gutter-box5" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { style: {"margin":"10px","float":"right"} }
const _hoisted_16 = { class: "gutter-box6" }
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "display-line1" }
const _hoisted_19 = { style: {"color":"gray","font-style":"italic"} }
const _hoisted_20 = { style: {"font-size":"14px","color":"gray"} }
const _hoisted_21 = { style: {"margin-top":"50px","width":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_font = _resolveComponent("icon-font")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_carousel = _resolveComponent("a-carousel")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_WechatOutlined = _resolveComponent("WechatOutlined")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_MailOutlined = _resolveComponent("MailOutlined")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_back_top = _resolveComponent("a-back-top")!
  const _component_the_footer = _resolveComponent("the-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { class: "container center-container" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_content, { class: "center-div" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { class: "gutter-row-1" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_a_card, {
                      hoverable: false,
                      bordered: true,
                      style: {"padding":"0px","margin":"0px 10px","height":"300px","cursor":"auto"},
                      bodyStyle: { padding: '5px' },
                      type: 'inner',
                      class: "card"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_list, { "data-source": _ctx.recommendArticles }, {
                          renderItem: _withCtx(({ item }) => [
                            _createVNode(_component_a_list_item, null, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  href: '/#/doc?articleId=' + item.articleVO.id,
                                  target: "_blank"
                                }, [
                                  _createElementVNode("span", _hoisted_3, [
                                    _createVNode(_component_icon_font, {
                                      type: "icon-tuijian",
                                      style: {"font-size":"16px"}
                                    }),
                                    _createTextVNode(" " + _toDisplayString(item.articleVO.title) + " ", 1),
                                    _createElementVNode("span", _hoisted_4, "(" + _toDisplayString(item.articleVO.description) + ")", 1)
                                  ])
                                ], 8, _hoisted_2)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 1
                        }, 8, ["data-source"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_a_carousel, { autoplay: "" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banners, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.id
                          }, [
                            _createElementVNode("a", {
                              href: item.link,
                              target: "_blank"
                            }, [
                              _createVNode(_component_a_image, {
                                height: 300,
                                preview: false,
                                src: item.bannerUrl
                              }, null, 8, ["src"])
                            ], 8, _hoisted_6)
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_a_card, {
                      hoverable: false,
                      bordered: true,
                      style: {"height":"300px","padding":"10px","margin":"0px 10px","text-align":"center","cursor":"auto"},
                      bodyStyle: { padding: '5px' },
                      type: 'inner',
                      class: "card"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_avatar, {
                                  size: 100,
                                  src: require('@/assets/user.jpg')
                                }, null, 8, ["src"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _hoisted_8,
                                _hoisted_9,
                                _createElementVNode("div", _hoisted_10, [
                                  _createVNode(_component_a_popover, { title: "微信二维码" }, {
                                    content: _withCtx(() => [
                                      _createVNode(_component_a_image, {
                                        width: 200,
                                        preview: false,
                                        src: require('@/assets/wechat.jpg')
                                      }, null, 8, ["src"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_WechatOutlined, { style: { fontSize: '18px', color: '#303133' } })
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode("     "),
                                  _createVNode(_component_a_popover, { title: "电子邮箱" }, {
                                    content: _withCtx(() => [
                                      _hoisted_11
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_MailOutlined, { style: { fontSize: '18px', color: '#303133' } })
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, { class: "gutter-row-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 3 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_a_card, {
                      hoverable: false,
                      bordered: true,
                      style: {"width":"160px","margin-left":"20px","padding":"0px","cursor":"pointer"},
                      bodyStyle: { padding: '5px' },
                      type: 'inner',
                      class: "card"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_menu, {
                          openKeys: _ctx.openKeys1,
                          "onUpdate:openKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.openKeys1) = $event)),
                          selectedKeys: _ctx.selectedKeys1,
                          "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedKeys1) = $event)),
                          style: {"width":"100%","border":"none","text-align":"center"},
                          mode: "vertical",
                          items: _ctx.items1,
                          onClick: _ctx.handleClick1
                        }, null, 8, ["openKeys", "selectedKeys", "items", "onClick"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 15 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_a_card, {
                      hoverable: false,
                      bordered: true,
                      style: {"padding":"0px","margin":"0px 10px","cursor":"auto"},
                      bodyStyle: { padding: '5px' },
                      type: 'inner',
                      class: "card"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_tabs, {
                          activeKey: _ctx.activeTabKey2,
                          "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeTabKey2) = $event)),
                          onTabClick: _ctx.handleTabClick2,
                          style: {"margin":"0px 20px"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items2, (tab) => {
                              return (_openBlock(), _createBlock(_component_a_tab_pane, {
                                key: tab.key,
                                tab: tab.name
                              }, null, 8, ["tab"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["activeKey", "onTabClick"]),
                        _createVNode(_component_a_list, {
                          "item-layout": "vertical",
                          "data-source": _ctx.articleData
                        }, {
                          renderItem: _withCtx(({ item }) => [
                            _createVNode(_component_a_list_item, null, _createSlots({
                              actions: _withCtx(() => [
                                _createElementVNode("span", null, [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent('UserOutlined'), { style: {"margin-right":"8px"} })),
                                  _createTextVNode(" " + _toDisplayString(item.viewCount), 1)
                                ]),
                                _createElementVNode("span", null, [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent('LikeOutlined'), { style: {"margin-right":"8px"} })),
                                  _createTextVNode(" " + _toDisplayString(item.voteCount), 1)
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_a_list_item_meta, null, _createSlots({
                                  title: _withCtx(() => [
                                    _createElementVNode("a", {
                                      href: '/#/doc?articleId=' + item.id,
                                      target: "_blank"
                                    }, _toDisplayString(item.title), 9, _hoisted_14)
                                  ]),
                                  description: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(item.description), 1)
                                  ]),
                                  _: 2
                                }, [
                                  (item.coverUrl != undefined && item.coverPos == 'left')
                                    ? {
                                        name: "avatar",
                                        fn: _withCtx(() => [
                                          _createVNode(_component_a_image, {
                                            width: 96,
                                            alt: "图片",
                                            src: item.coverUrl
                                          }, null, 8, ["src"])
                                        ]),
                                        key: "0"
                                      }
                                    : undefined
                                ]), 1024),
                                _createTextVNode(" " + _toDisplayString(item.summary), 1)
                              ]),
                              _: 2
                            }, [
                              (item.coverUrl != undefined && item.coverPos == 'right')
                                ? {
                                    name: "extra",
                                    fn: _withCtx(() => [
                                      _createVNode(_component_a_image, {
                                        height: 96,
                                        alt: "图片",
                                        src: item.coverUrl
                                      }, null, 8, ["src"])
                                    ]),
                                    key: "0"
                                  }
                                : undefined
                            ]), 1024)
                          ]),
                          _: 1
                        }, 8, ["data-source"]),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_a_pagination, {
                            current: _ctx.currentPage,
                            "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentPage) = $event)),
                            pageSize: _ctx.currentSize,
                            "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentSize) = $event)),
                            total: _ctx.total,
                            onChange: _ctx.onPageChange,
                            onShowSizeChange: _ctx.onShowSizeChange
                          }, null, 8, ["current", "pageSize", "total", "onChange", "onShowSizeChange"])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_a_card, {
                      hoverable: false,
                      bordered: true,
                      style: {"padding":"0px","margin":"0px 10px","cursor":"auto"},
                      bodyStyle: { padding: '5px' },
                      type: 'inner',
                      title: "热门文章 Top10",
                      class: "card"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_list, {
                          bordered: false,
                          "data-source": _ctx.hotArticles,
                          style: {"margin":"0px"}
                        }, {
                          renderItem: _withCtx(({ item, index }) => [
                            _createVNode(_component_a_list_item, null, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  href: '/#/doc?articleId=' + item.id,
                                  target: "_blank"
                                }, [
                                  _createElementVNode("span", _hoisted_18, [
                                    _createElementVNode("span", _hoisted_19, _toDisplayString((index + 1) + '. '), 1),
                                    _createTextVNode(" " + _toDisplayString(item.title) + " ", 1),
                                    _createElementVNode("span", _hoisted_20, "(" + _toDisplayString(item.description) + ")", 1)
                                  ])
                                ], 8, _hoisted_17)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 1
                        }, 8, ["data-source"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_back_top, { type: "default" }),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_the_footer)
      ])
    ]),
    _: 1
  }))
}